import PropTypes from 'prop-types';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import './Tooltip.css';

const Tooltip = (props) => {
    return (
        <Tippy content={props.content} {...props}>
            <div>{props.children}</div>
        </Tippy>
    );
};

Tooltip.propTypes = {
    content: PropTypes.node,
    children: PropTypes.node,
};

export default Tooltip;
